export default function NoticeBar({ children,className }) {
  return (
    <div className="py-[8px] px-[15px] bg-[#fef6e3] md:hidden">
      {children}
    </div>
  )
}
